// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandTagOfficial_container__3edLe","desc":"BrandTagOfficial_desc___hyMa","label":"BrandTagOfficial_label__3XNy9"};